import React from 'react';
import { Button as ButtonComponent } from '@mui/material';
import buttonStyles from '../../../stylesheets/components/buttons.module.scss';
import classNames from 'classnames';
import loginStyles from '../../../stylesheets/components/login.module.scss';

interface LoginButtonProps {
  id?: string;
  dataId?: string;
  onClick: () => void;
  logoPath: string;
  className?: string;
  logoClassName?: string;
  helperId?: string;
  helperText?: React.ReactNode;
  helperTestClass?: string;
  invalid?: boolean;
  children: React.ReactNode;
}

const Button = ({
  id,
  dataId,
  onClick,
  logoPath,
  className,
  logoClassName,
  helperId,
  helperText,
  helperTestClass,
  invalid,
  children,
}: LoginButtonProps) => {
  return (
    <div className={loginStyles.loginOptionButtonGroup}>
      <ButtonComponent
        aria-describedby={helperText ? helperId : undefined}
        aria-invalid={invalid || undefined}
        id={id}
        data-id={dataId}
        className={classNames(
          buttonStyles.button,
          buttonStyles.social,
          className
        )}
        onClick={onClick}
      >
        <>
          <img
            src={logoPath}
            className={classNames(buttonStyles.logo, logoClassName)}
          />
          {children}
        </>
      </ButtonComponent>
      {helperText && (
        <p
          className={classNames(
            loginStyles.loginOptionButtonHelper,
            loginStyles.loginOptionButtonHelperError
          )}
          data-test-class={helperTestClass}
          id={helperId}
        >
          {helperText}
        </p>
      )}
    </div>
  );
};

export default Button;
